module.exports = __webpack_public_path__ + "img/news_industry.4f4211e1.png";